<template>
    <div
        class  = "mr-1 v-flex pa-1 doc-panel"
        @click = "onDocument"
    >
        <div>
            <v-switch
                v-model       = "state"
                class         = "doc-switch"
                :hide-details = "true"
                :ripple       = "false"
                @change       = "onSelected"
                @click.native.stop
            />
        </div>
        <div style="display: block; padding-top: 3px;" class="pl-1 v-flex" >
            <div class="doc-info v-flex">
                <c-inc-document-icon
                    class="pr-0"
                    style="margin-top: -4px; max-height: 20px; margin-right: 2px;"
                    :document = "document"
                    :size = "22"
                />

                <!-- unit chip -->
                <div v-if="document.unitName" class="doc-unit mr-1 primary white--text">
                    {{ document.unitName }}
                </div>
                <!-- unit chip -->

                <!-- bid chip -->
                <div v-if="document.bidId" class="primary white--text">
                    {{ bidname }}
                </div>
                <!-- bid chip -->

                <div class="doc-execution" v-if="document.executionDate">
                    {{ document.executionDate ? dateAsString ( document.executionDate) : '---'}}
                </div>

                <!-- document type -->
                <div>
                    {{ document.type ? document.type.name : '---'}}
                </div>
                <!-- document type -->
            </div>

            <div class="doc-subinfo doc-filename">
                {{ document.name }}
            </div>
        </div>
    </div>
</template>

<script>

import Core             from "@/modules/core/service/Core";
import CIncDocumentIcon from "@/modules/dms/common/components/CIncDocumentIcon.vue";
import Dms from "@/modules/dms/common/service/Dms";

export default {
    name: "PIncSelectableDocument",

    components: {
        CIncDocumentIcon,
    },

    props: {
        document: {

        },

        selected: {

        }
    },

    data: () => ({
        state: false,
    }),

    computed: {
        bidname () {
            return this.$t("repair.bid.name." + this.document.bidName);
        },
    },

    mounted() {
        this.state = this.selected;
    },

    watch: {
        selected () {
            this.state = this.selected;
        }
    },

    methods: {
        onSelected () {
            this.$emit("selected", {
                selected: this.state,
                document: this.document
            });
        },

        onDocument () {
            Dms.open(this.document.id, this.document.name)
        },

        dateAsString (value) {
            return Core.format.date.display(value);
        },

        timeAsString (value) {
            return Core.format.datetime.display(value);
        },
    }
}
</script>

<style scoped>

.doc-switch {
    margin-top: 9px;
    margin-left: 10px;
    padding-top: 0;
}

.doc-panel {
    cursor: pointer;
}

.doc-info {
    font-size: 14px;
    padding-top: 1px;
}

.doc-unit {
    font-size: 12px;
    padding-left: 8px;
    padding-right: 8px;
    height: 18px;
    line-height: 18px;
    margin-top: 2px;
    min-width: 80px;
    text-align: center;
    border-radius: 2px;
}

.doc-subinfo {
    font-size: 11px;
    margin-top: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.doc-filename {
    max-width: 330px;
    width: 330px;
}

.doc-execution {
    width: 80px;
}

</style>